import {
  LayoutBase,
} from "@livat-web/ui";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from "react";
import { showCrowdIndicator } from "../../constants/app.constants";
import meetingPlaces from '../../data/meetingPlace.json';
import { applyLanguageChange } from '../../helpers/language.helper';
import { appDefaults } from "../../config";

if (typeof window !== 'undefined') {
  require('@livat-web/ui/styles');
  // require('@livat-web/ui/fonts');
  require('@livat-web/ui/fold-out-menu');
  require('@livat-web/ui/social-media-links-list');
  require('@livat-web/ui/search-widget');
  require('@livat-web/ui/elastic');
  require('@livat-web/ui/scrollbar');
  require('@livat-web/ui/backdrop');
  require('@livat-web/ui/forms');
}

const BaseLayout = ({ children }) => {
  const dispatch = useDispatch();
  const locale = useSelector(state => state?.app?.selectedLanguage)
  const appMeetingPlace = useSelector(state => state?.app?.meetingPlace);
  const appCountry = useSelector(state => state?.app?.country);
  // const layoutData = useSelector(state => state?.app?.baseLayout)
  // const crowdIndicator = useSelector(state => state?.app?.crowdIndicator)
  const { t, i18n } = useTranslation()
  // const [footerLink, setFooterLink] = useState([]);
  // const [todayHours, setTodayHours] = useState(null);
  // const [feedbackModalOpen, setFeedbackModalOpen] = useState(false)
  // const domain = (layoutData?.domain || window.location.origin || '').replace(/\/+$/, '');
  // const urlPrefix = `${domain}/${locale ?? 'en'}`;

  /**
   * Handles the language change fired by the shared `LayoutBase` component.
   * Actual logic lives in `helpers/language.helper.js` (`applyLanguageChange`),
   * which resolves the correct country, updates i18n/moment, dispatches redux
   * updates and rewrites the language segment in the URL.
   */
  const handleLanguageChange = (languageCode) => {
    applyLanguageChange({
      languageCode,
      currentLanguage: locale,
      currentCountry: appCountry,
      i18n,
      dispatch,
    });
  };

 /** 
  useEffect(() => {
    if(showCrowdIndicator) {
      fetchCrowdIndicatorData({ "mpId": appMeetingPlace?.mpid, "timezone": layoutData?.meetingPlace?.timezone }, dispatch)
    }
  }, [layoutData?.meetingPlace?.timezone, appMeetingPlace?.mpid])
  useEffect(() => {
    if (!layoutData) return;

    const linkCollectionItems = layoutData?.footer?.linksCollection?.items?.map((element) => ({
      pagesCollection: {
        items: element?.pagesCollection?.items?.map((item) => {
          return ({
            name: item?.__typename === 'LibraryExternalLink' ? item?.linkTitle : item?.name,
            linkHref: item?.__typename === 'LibraryExternalLink' ? item?.linkHref : `${urlPrefix}/${item.slug}`,
            linkTitle: item?.__typename === 'LibraryExternalLink' ? item?.linkTitle : item?.name
          })
        })
      }
    }));

    const hours = getTodayHours(
      layoutData.meetingPlace.openingHours,
      layoutData.meetingPlace.timezone,
      locale,
    );
    setTodayHours(hours);
    setFooterLink(linkCollectionItems)
  }, [layoutData])


  const openingSlot = () => {
    return (
      <>
        <div className="livat-web-mb-3 livat-web-font-title livat-web-text-headings livat-web-font-bold">
          <OpeningHours
            variant="today"
            openingHoursClosed={
              'Cerrado'
            }
            openingHoursClosedToday={
              'Cerrado hoy'
            }
            openingHoursOpenToday={
              'Abierto hoy'
            }
            openingHours={layoutData?.meetingPlace?.openingHours}
            openingHoursExceptions={layoutData?.meetingPlace?.openingHoursExceptionsCollection?.items?.filter(
              Boolean,
            )}
            timezone={layoutData?.meetingPlace?.timezone}
            node_locale={locale}
          />
        </div>
        <div className="livat-web-text-text-light">
          <OpeningHours
            openingHoursClosed={
              'Cerrado'
            }
            openingHoursClosedToday={
              'Cerrado hoy'
            }
            openingHoursOpenToday={
              'Abierto hoy'
            }
            openingHours={layoutData?.meetingPlace?.openingHours}
            openingHoursExceptions={layoutData?.meetingPlace?.openingHoursExceptionsCollection?.items?.filter(
              Boolean,
            )}
            timezone={layoutData?.meetingPlace?.timezone}
            node_locale={locale}
            variant="compact"
          />
        </div>
      </>
    )
  }
    */

  return (
    <LayoutBase 
      pathPrefix={appDefaults.environment==='prod' ? appMeetingPlace?.pathPrefix?.prod : appMeetingPlace?.pathPrefix?.dev}
      apiUrl={appDefaults.environment!=='prod' ? process.env.REACT_APP_SHARED_LAYOUT_API_SERVER_URL: appMeetingPlace?.mpWebUrl} 
      withData={true} 
      locale={locale} 
      pageId={appMeetingPlace?.homePageId}
      elasticEngineName={appMeetingPlace?.elasticEngineName}
      tagContentfulId={appMeetingPlace?.tagContentfulId}
      widgetUrl={process.env.REACT_APP_WIDGET_URL}
      isChatbotEnabled={appMeetingPlace?.isChatbotEnabled?.[appDefaults.environment] ?? false}
      elasticSearchKey ={process.env.REACT_APP_ELASTIC_SEARCH_KEY}
      elasticEndpointBase={process.env.REACT_APP_ELASTIC_ENDPOINT}
      onLanguageChange={handleLanguageChange}>
        {children}
    </LayoutBase>
  )
  /**
  return (
    <>
      <LayoutBase headerProps={{
        logoUrl: layoutData?.meetingPlace?.logo?.url,
        homeHref: urlPrefix,
        title: layoutData?.meetingPlace?.name,
        logoAspectRatio: Math.floor(layoutData?.meetingPlace?.logo?.height / layoutData?.meetingPlace?.logo?.height),
        meetingPlace: {
          name: layoutData?.meetingPlace?.name,
          openingHourPageLink: urlPrefix + '/' + layoutData?.meetingPlace?.openingHoursLink?.slug,
          openingHourToday: `${t('S_OPEN_TODAY')} ${todayHours?.open || ''}-${todayHours?.close || ''}`,
          showCrowdLevel: showCrowdIndicator,
          crowdLevel: crowdIndicator ?? null,
          crowdText: t('S_CROWD')
        }
      }}
        onFeedbackClick={() => {
          console.log('clicked');
          setFeedbackModalOpen(true)
        }}
        footer={{
          name: layoutData?.meetingPlace?.name,//"MAR Shopping Algarve",
          linkGroupsSlot: { items: footerLink ?? [] },
          // addressLines: ["Avenida do Algarve, Complexo Industrial IKEA 8135-182 Loulé, Algarve"],
          addressStreet: layoutData?.meetingPlace?.visitorsAddressStreet, //"Avenida Doutor Óscar Lopes",
          addressStreet2: layoutData?.meetingPlace?.visitorsAddressStreet2,//"Leça da Palmeira",
          addressCity: layoutData?.meetingPlace?.visitorsAddressCity,//"Matosinhos, Portugal",
          addressZipCode: layoutData?.meetingPlace?.visitorsAddressZipCode,//"4450-337",
          phoneNumber: layoutData?.meetingPlace?.phoneNumber, //"(+351) 289 247 842 (chamada para rede fixa nacional)",
          copyrightText: '© Ingka Centres Holding B.V. ' + new Date().getFullYear(),
          logoUrl: layoutData?.meetingPlace?.logo?.url,
          logoAspectRatio: Math.floor(layoutData?.meetingPlace?.logo?.height / layoutData?.meetingPlace?.logo?.height),
          socialLinks: [
            { href: layoutData?.meetingPlace?.socialMediaLinks?.webUrl, title: "Website Icon", icon: <WebsiteIcon /> }, 
            { href: layoutData?.meetingPlace?.socialMediaLinks?.facebookUrl, title: "Facebook Icon", icon: <FacebookIcon /> },
            { href: layoutData?.meetingPlace?.socialMediaLinks?.instagramUrl, title: "Instagram Icon", icon: <InstagramIcon /> },
            { href: layoutData?.meetingPlace?.socialMediaLinks?.youTubeUrl, title: "YouTube Icon", icon: <YouTubeIcon /> },
          ],
          // socialIconsClass:`${styles.social}`,
          socialIconsClass: "grid h-11 w-11 place-items-center rounded-full bg-transparent outline-0 transition-colors hover:bg-neutral-grey-100 focus:bg-transparent focus-visible:outline focus-visible:outline-3 focus-visible:outline-offset-3 focus-visible:outline-icon-dark active:bg-neutral-grey-200",
          feedbackText: layoutData?.footer?.feedbackText, // "Adorávamos saber a sua opinião",
          feedbackLinkText: layoutData?.footer?.feedbackLinkText,  // "Dê-nos o seu feedback",
          openingHoursSlot: openingSlot(),
          allOpeningHoursLinkText: layoutData?.footer?.allOpeningHoursLinkText, //"Ver horário completo",
          allOpeningHoursLinkHref: urlPrefix + '/' + layoutData?.footer?.allOpeningHoursPageLink?.slug,
          cookieSettingsText: t('S_COOKIES_SETTINGS') 
        }}>
        {children}
      </LayoutBase>


      <ModalBase
        isOpen={feedbackModalOpen}
        handleClose={() => setFeedbackModalOpen(false)}
      >
        <ModalBodyBase>
          <iframe
            className="livat-web-h-full livat-web-w-full livat-web-border-none livat-web-lg:p-5"
            src={layoutData?.footer?.feedbackUrl}
          ></iframe>
        </ModalBodyBase>
      </ModalBase>
    </>
  )
     */
};

export default BaseLayout;